interface MediaItem {
  title: string;
  duration: string;
  views: string;
  imageUrl: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '【漫评】2026上半年韩漫神作盘点，每一部都值得N刷',
    duration: '12:36',
    views: '8.3w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20with%20warm%20coral%20and%20cream%20gradient%2C%20abstract%20cinematic%20composition%2C%20soft%20lighting%2C%20no%20text%20no%20characters%2C%20modern%20editorial%20design%20with%20play%20button%20area&width=560&height=315&seq=media-01&orientation=landscape',
  },
  {
    title: '国漫崛起之路：从模仿到超越的十年蜕变',
    duration: '18:22',
    views: '6.7w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20with%20amber%20golden%20and%20cream%20gradient%2C%20abstract%20documentary%20style%20composition%2C%20warm%20atmosphere%2C%20no%20text%20no%20characters%2C%20cinematic%20editorial%20design&width=560&height=315&seq=media-02&orientation=landscape',
  },
  {
    title: '日漫恋爱题材推荐：那些让人心动不已的纯爱名作',
    duration: '09:15',
    views: '5.9w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20with%20soft%20pink%20coral%20and%20cream%20gradient%2C%20abstract%20romantic%20composition%2C%20gentle%20atmosphere%2C%20no%20text%20no%20characters%2C%20dreamy%20editorial%20design&width=560&height=315&seq=media-03&orientation=landscape',
  },
  {
    title: '漫画分镜大师课：解析顶级漫画家的叙事技巧',
    duration: '25:40',
    views: '4.2w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20with%20muted%20sage%20green%20and%20cream%20gradient%2C%20abstract%20educational%20composition%2C%20clean%20modern%20atmosphere%2C%20no%20text%20no%20characters%2C%20professional%20editorial%20design&width=560&height=315&seq=media-04&orientation=landscape',
  },
  {
    title: '深夜追漫必备：那些让人睡不着的高能悬疑漫画',
    duration: '15:08',
    views: '7.1w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20with%20dark%20moody%20coral%20red%20and%20charcoal%20gradient%2C%20abstract%20mysterious%20composition%2C%20suspenseful%20atmosphere%2C%20no%20text%20no%20characters%2C%20dramatic%20cinematic%20design&width=560&height=315&seq=media-05&orientation=landscape',
  },
];

export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
          漫画相关精彩内容推荐
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-primary-500">
                      <i className="ri-play-fill text-xl md:text-2xl"></i>
                    </span>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/70 text-background-50 text-[10px] font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-xs md:text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-[11px] text-foreground-500 mt-1.5">
                  {item.views}次播放
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}